import { render, staticRenderFns } from "./ques5.vue?vue&type=template&id=26e5fcb5"
import script from "./ques5.vue?vue&type=script&lang=js"
export * from "./ques5.vue?vue&type=script&lang=js"
import style0 from "./ques5.vue?vue&type=style&index=0&id=26e5fcb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports